import { Button, ShowButtonProps } from 'react-admin';
import { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';

const ShowTabButton = ({ ...props }: ShowButtonProps): ReactElement => {
  const currentPath = useLocation();
  const pathParts = currentPath.pathname.split('/');
  // Strip trailing edit tab segment (e.g. /info), insert 'show', add /info
  const withoutEditTab = pathParts.slice(0, pathParts.length - 1);
  withoutEditTab.splice(withoutEditTab.length, 0, 'show', 'info');
  const showLink = withoutEditTab.join('/');

  return <Button label="Show" href={'#' + showLink} />;
};

const EditTabButton = ({ ...props }: ShowButtonProps): ReactElement => {
  const currentPath = useLocation();
  const pathParts = currentPath.pathname.split('/');
  // Remove 'show' segment and trailing tab segment, then add edit tab /info
  const showIndex = pathParts.indexOf('show');
  const withoutShow = pathParts.filter((_, i) => i !== showIndex);
  // strip trailing show-tab segment (e.g. /info)
  const withoutShowTab = withoutShow.slice(0, withoutShow.length - 1);
  withoutShowTab.push('info');
  const editLink = withoutShowTab.join('/');

  return <Button label="Edit" href={'#' + editLink} />;
};

export { EditTabButton, ShowTabButton };
